// src/hooks/useTailwindBreakpoints.ts
import { useState, useEffect } from "react";

interface Breakpoints {
  xs: boolean;
  sm: boolean;
  md: boolean;
  lg: boolean;
  xl: boolean;
  "2xl": boolean;
  "3xl": boolean;
  "4xl": boolean;
  "5xl": boolean;
  "6xl": boolean;
  "8xl": boolean;
}

const useTailwindBreakpoints = (): Breakpoints => {
  const [breakpoints, setBreakpoints] = useState<Breakpoints>({
    xs: false,
    sm: false,
    md: false,
    lg: false,
    xl: false,
    "2xl": false,
    "3xl": false,
    "4xl": false,
    "5xl": false,
    "6xl": false,
    "8xl": false,
  });

  useEffect(() => {
    const mediaQueryLists = {
      xs: window.matchMedia("(min-width: 320px)"),
      sm: window.matchMedia("(min-width: 640px)"),
      md: window.matchMedia("(min-width: 768px)"),
      lg: window.matchMedia("(min-width: 1024px)"),
      xl: window.matchMedia("(min-width: 1280px)"),
      "2xl": window.matchMedia("(min-width: 1440px)"),
      "3xl": window.matchMedia("(min-width: 1600px)"),
      "4xl": window.matchMedia("(min-width: 1920px)"),
      "5xl": window.matchMedia("(min-width: 2560px)"),
      "6xl": window.matchMedia("(min-width: 3840px)"),
      "8xl": window.matchMedia("(min-width: 7680px)"),
    };

    const updateBreakpoints = () => {
      setBreakpoints({
        xs: mediaQueryLists.xs.matches,
        sm: mediaQueryLists.sm.matches,
        md: mediaQueryLists.md.matches,
        lg: mediaQueryLists.lg.matches,
        xl: mediaQueryLists.xl.matches,
        "2xl": mediaQueryLists["2xl"].matches,
        "3xl": mediaQueryLists["3xl"].matches,
        "4xl": mediaQueryLists["4xl"].matches,
        "5xl": mediaQueryLists["5xl"].matches,
        "6xl": mediaQueryLists["6xl"].matches,
        "8xl": mediaQueryLists["8xl"].matches,
      });
    };

    // Set initial breakpoints state
    updateBreakpoints();

    // Add event listeners
    Object.values(mediaQueryLists).forEach((mql) => {
      mql.addEventListener("change", updateBreakpoints);
    });

    // Cleanup event listeners on unmount
    return () => {
      Object.values(mediaQueryLists).forEach((mql) => {
        mql.removeEventListener("change", updateBreakpoints);
      });
    };
  }, []);

  return breakpoints;
};

export default useTailwindBreakpoints;
